import React from 'react';
import styled from 'styled-components';
import Education from '../components/Education';

const PageStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const EducationPage = () => (
  <PageStack>
    <Education />
  </PageStack>
);

export default EducationPage;

